import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { PLAYER_WIN_ANIMATION_SET } from '../../../animations/animationDefinitions';
import { POKER_SEAT_ROUNDED_RECT_RADIUS } from '../../../constants/constants';
import { useAppSelector } from '../../../redux/store';
import { WIN_GREEN_COLOR_NUM } from '../../../styles/colors';
import { isTestEnvironment } from '../../../utils/utils';
import { AnimationContainer } from '../pixiComponents/animationContainer';
import { Rect } from '../pixiComponents/rect';
// Above this size threshold (both seat width and height), show an outline border instead of a solid background
const SOLID_THRESHOLD_PX = 100;
export const PlayerWinAnimationContainer = ({ seatIndex }) => {
    const seatDimensions = useAppSelector((state) => state.gameDimensions.seatDimensions, shallowEqual);
    const startTimestampMs = useAppSelector((state) => {
        if (!state.poker.winningSeatIndexes?.includes(seatIndex)) {
            // not a winning seat
            return;
        }
        return state.poker.currentShowdown?.startTimeStampMs;
    });
    if (seatDimensions === undefined || startTimestampMs === undefined) {
        return null;
    }
    const { w, h } = seatDimensions;
    const x = -w / 2;
    const y = -h / 2;
    const showAsSolid = w < SOLID_THRESHOLD_PX || h < SOLID_THRESHOLD_PX;
    const pixiData = isTestEnvironment() ? { type: 'player-winning', seatIndex } : null;
    const colorNum = WIN_GREEN_COLOR_NUM;
    const contents = showAsSolid ? (_jsx(Rect, { x: x, y: y, w: w, h: h, fillColor: colorNum, radius: POKER_SEAT_ROUNDED_RECT_RADIUS })) : (_jsx(Rect, { x: x, y: y, w: w, h: h, lineWidth: 15, lineColor: colorNum, radius: POKER_SEAT_ROUNDED_RECT_RADIUS }));
    return (_jsx(Container, { "pixi-data": pixiData, interactiveChildren: false, children: _jsx(AnimationContainer, { animationSet: PLAYER_WIN_ANIMATION_SET, startTimestampMs: startTimestampMs, children: contents }) }));
};
